import React, { useState } from "react";
import Modal from "../../../../../../common/Modal";
import SuccessfullMatch from "../SuccessfullMatch";

import {
  MenteeMatchModalTitle,
  MenteeMatchRow,
  MenteeMatchCol,
  Info,
  InfoName,
  InfoRole,
  InfoImage,
} from "./styles.js";

const MenteeMatch = ({
  isOpen,
  closeModal,
  matchedParticipants,
  reassignMentee,
  successModal,
  setSuccessModal,
  isClose,
}) => {
  const menteeName = matchedParticipants[0]?.participant?.firstName;
  const mentorName = matchedParticipants[1]?.participant?.firstName;
  const menteeId = matchedParticipants[0]?.participantId;
  const mentorId = matchedParticipants[1]?.id;
  return (
    <>
      {isOpen && (
        <Modal
          isButtonCenter={true}
          isNotRound={true}
          isTask={true}
          onClose={() => closeModal(false)}
          title={
            <MenteeMatchModalTitle>
              {menteeName} and {mentorName} look like a perfect fit. <br />
              Shall we make it official?
            </MenteeMatchModalTitle>
          }
          actions={[
            {
              text: "Cancel",
              onClick: () => {
                closeModal(false);
              },
            },
            {
              text: "Match",
              onClick: () => {
                reassignMentee(mentorId, menteeId);
              },
            },
          ]}
        >
          <MenteeMatchRow>
            {matchedParticipants.map((person) => (
              <MenteeMatchCol key={person.id}>
                <InfoImage>
                  <img
                    src={
                      person.image
                        ? person.image
                        : person.participant.image
                        ? person.participant.image
                        : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                    }
                    alt={`Mentor ${person.firstName ? person.firstName : person.participant.firstName}`}
                  />
                </InfoImage>

                <Info>
                  <InfoName>{person.firstName ? person.firstName : person.participant.firstName}</InfoName>
                  <InfoRole>{person.joinAs}</InfoRole>
                </Info>
              </MenteeMatchCol>
            ))}
          </MenteeMatchRow>
        </Modal>
      )}
      {successModal && (
        <SuccessfullMatch
          isClose={isClose}
          menteeName={menteeName}
          mentorName={mentorName}
          closeModal={setSuccessModal}
        />
      )}
    </>
  );
};

export default MenteeMatch;
